module.exports = __webpack_public_path__ + "img/verification.5a34e2d8.png";